export enum TrailType {
  Entity = 0,
  Activity
}
